<template>
  <a-page-header
    style="border: 1px solid rgb(235, 237, 240)"
    :title="title"
    :sub-title="subTitle"
  >
    <template #extra>
      <slot name="extra"></slot>
    </template>
  </a-page-header>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    subTitle: {
      type: String,
    },
  },
};
</script>
